import { PaginatedQueryParams } from "@/store/types"
import PagedResponse from "./PagedResponse"

export interface AreaEventHistory {
    created: Date,
	groupCreated: Date,
    closed: Date,
	groupClosed: Date,
    type: string,
    user: string,
    details: string,
    priority: number,
    category: string,
    note: string,
    eventId: number
}

export interface AreaEventHistoryWithPagination extends PagedResponse {
    data: AreaEventHistory[]
}

export interface AreaEventHistoryPaginatedSearchParams extends PaginatedQueryParams {
    fromDate: Date,
    toDate: Date,
    groupId: number,
    eventHistoryTypeIds: number[],
    includeAutohandled: boolean,
    responseIds: number[]
}

export enum AreaEventHistoryTypeIds {
    Event = 1,
    Masking = 2,
    OnTest = 3
}

export enum AreaEventHistoryTypeNames {
    Event = "Event",
    Masking = "Masking",
    OnTest = "OnTest"
}